module.exports = __webpack_public_path__ + "resources/img/img_watchall_dbms01.a8d84dc4f0894e831caca5b015e6ce3e.png";